module.exports = __webpack_public_path__ + "img/logo_light.371101e9.png";